module.exports = __webpack_public_path__ + "img/image-2.3.99e714a.svg";